module.exports = __webpack_public_path__ + "static/img/20170510155226_7777.271d205.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20170510155226_7777.jpg
// module id = zkE4
// module chunks = 1